export default __webpack_public_path__ + "static/media/trash-biohazard.960069e7.svg";